import {
  getPreEligibilityHourlyData,
  getSalesDropData,
  getStageWiseHourlyData,
  PreEligibilityApiRow,
  SalesDropApiResponse,
  StageWiseApiRow,
} from "../pages/FunnelMonitoring/hook/API";

export type { SalesDropApiResponse };

export interface HourlyFunnelData {
  hour_range: string;
  [key: string]: string | number;
  created: number;
}

export interface PreEligibilityHourlyData {
  hour_range: string;
  total_pre_eligibility: number;
  pre_registration: number;
  post_registration: number;
  middleware_customer_block: number;
  eligible_count: number;
  not_eligible_count: number;
  eligible_percent: number;
  not_eligible_percent: number;
}


const toStageWiseRow = (row: StageWiseApiRow): HourlyFunnelData => ({
  hour_range: row.hourRange,
  preloan_eligibility: row.preloanEligibility ?? 0,
  created: row.created ?? 0,
  locked: row.locked ?? 0,
  salary_check: row.salaryCheck ?? 0,
  verified: row.verified ?? 0,
  parking_stage: row.parkingStage ?? 0,
  hard_rejected: row.hardRejected ?? 0,
  commodity_purchased_requested: row.commodityPurchasedRequested ?? 0,
  commodity_purchased: row.commodityPurchased ?? 0,
  app_custcared: row.appCustcared ?? 0,
  call_initialized_unique: row.callInitializedUnique ?? row.callInitialized ?? 0,
  call_approved: row.callApproved ?? 0,
  contract_signed: row.contractSigned ?? 0,
  sanad_created: row.sanadCreated ?? 0,
  nafaes_sales_ordered: row.nafaesSalesOrdered ?? 0,
  disbursed: row.disbursed ?? 0,
  withdrawal_requested: row.withdrawalRequested ?? 0,
  withdrawal_success: row.withdrawalSuccess ?? 0,
  preloan_to_created_drop_percent: row.preloanToCreatedDropPercent ?? 0,
  created_to_verified_percent: row.createdToVerifiedPercent ?? 0,
  verified_to_app_custcared_percent: row.verifiedToAppCustcaredPercent ?? 0,
  app_custcared_to_call_initialized_percent: row.appCustcaredToCallInitializedPercent ?? 0,
  call_initialized_to_call_approved_percent: row.callInitializedToCallApprovedPercent ?? 0,
  call_approved_to_contract_signed_percent: row.callApprovedToContractSignedPercent ?? 0,
  contract_signed_to_sanad_created_percent: row.contractSignedToSanadCreatedPercent ?? 0,
  sanad_created_to_nafaes_sales_ordered_percent: row.sanadCreatedToNafaesSalesOrderedPercent ?? 0,
  preloan_to_created_alert: row.preloanToCreatedAlert ?? 0,
  created_to_verified_alert: row.createdToVerifiedAlert ?? 0,
  verified_to_app_custcared_alert: row.verifiedToAppCustcaredAlert ?? 0,
  app_custcared_to_call_initialized_alert: row.appCustcaredToCallInitializedAlert ?? 0,
  call_initialized_to_call_approved_alert: row.callInitializedToCallApprovedAlert ?? 0,
  call_approved_to_contract_signed_alert: row.callApprovedToContractSignedAlert ?? 0,
  contract_signed_to_sanad_created_alert: row.contractSignedToSanadCreatedAlert ?? 0,
  sanad_created_to_nafaes_sales_ordered_alert: row.sanadCreatedToNafaesSalesOrderedAlert ?? 0,
});

const toPreEligibilityRow = (row: PreEligibilityApiRow): PreEligibilityHourlyData => ({
  hour_range: row.hourRange,
  total_pre_eligibility: row.totalPreEligibility ?? 0,
  pre_registration: row.preRegistration ?? 0,
  post_registration: row.postRegistration ?? 0,
  middleware_customer_block: row.middlewareCustomerBlock ?? 0,
  eligible_count: row.eligibleCount ?? 0,
  not_eligible_count: row.notEligbileCount ?? row.notEligibleCount ?? 0,
  eligible_percent: row.eligiblePercent ?? 0,
  not_eligible_percent: row.notEligiblePercent ?? 0,
});

const getHourSortValue = (hourRange: string): number => {
  const normalized = hourRange.trim();
  const splitByDash = normalized.split("-");
  if (splitByDash.length >= 1 && splitByDash[0] !== "") {
    const startHour = Number.parseInt(splitByDash[0], 10);
    if (!Number.isNaN(startHour)) {
      return startHour;
    }
  }

  const splitByColon = normalized.split(":");
  if (splitByColon.length >= 1 && splitByColon[0] !== "") {
    const startHour = Number.parseInt(splitByColon[0], 10);
    if (!Number.isNaN(startHour)) {
      return startHour;
    }
  }

  return -1;
};

const sortByLatestHour = <T extends { hour_range: string }>(rows: T[]): T[] => {
  return [...rows].sort((a, b) => getHourSortValue(b.hour_range) - getHourSortValue(a.hour_range));
};

export const getHourlyFunnelData = async (signal?: AbortSignal): Promise<HourlyFunnelData[]> => {
  const rows = await getStageWiseHourlyData(signal);
  return sortByLatestHour(rows.map(toStageWiseRow));
};

export const getPreEligibilityHourly = async (
  signal?: AbortSignal
): Promise<PreEligibilityHourlyData[]> => {
  const rows = await getPreEligibilityHourlyData(signal);
  return sortByLatestHour(rows.map(toPreEligibilityRow));
};

export const getSalesDrop = async (signal?: AbortSignal): Promise<SalesDropApiResponse | null> => {
  return getSalesDropData(signal);
};
